import bridgeEvent from '@/constants/bridge-event'
import appendQuery from 'append-query'

import storage from '@/helpers/storage'
import STORAGE from '@/constants/storage'
import session from '@/helpers/session'

const processData = {
  [bridgeEvent.navigate]: (data) => {
    let encode = true
    if (data.encode !== undefined) {
      encode = data.encode
    }
    return {
      schema: appendQuery(data.schema, data.data, {encodeComponents: encode})
    }
  },
  [bridgeEvent.action]: data => data,
  [bridgeEvent.share]: data => data
}

let timer = null
let timer2 = null
let timer3 = null
// let timer4 = null

export default {
  methods: {
    fireEvent (event, data, callback) {
      const eventData = processData[event](data)
      console.info('js bridge event:', event, 'data:', eventData)
      console.info('callback:', callback)
      if (window.YTXBridge) {
        window.YTXBridge.fireEvent(event, eventData, callback)
      }
    },
    /*
    fireEvent (event, data, callback) {
      const eventData = processData[event](data)
      console.info('js bridge event:', event, 'data:', eventData)
      console.info('callback:', callback)
      if (window.YTXBridge) {
        if (this.os === 'ios') {
          window.YTXBridge.fireEvent(event, eventData)
          this.updateUser(callback)
        } else {
          window.YTXBridge.fireEvent(event, eventData, callback)
        }
      }
    },
    * */
    getUpdateUser (next) {
      if (!this.inApp) return
      timer = setInterval(() => {
        if (window.YTXBridge) {
          clearInterval(timer)
          window.YTXBridge.registerHandler('updateUser', async (cb) => {
            console.log('getUpdateUser')
            console.log('isinlogin start', !!storage.get(STORAGE.IS_IN_LOGIN))
            try {
              cb = JSON.parse(cb)
              let isInLogin = !!storage.get(STORAGE.IS_IN_LOGIN)
              if (this.os === 'ios' && isInLogin) {
                storage.set(STORAGE.IS_IN_LOGIN, false)
              } else {
                if (session.get(STORAGE.LOGIN_TOKEN) === cb.token) {
                  return
                }
              }
              console.log('data', cb)
              this.SET_USER(cb.userId)
              session.set(STORAGE.USERID, cb.userId)
              cb.userId && this.$sa.LOGIN(cb.userId)
              if (cb.token) {
                this.SET_TOKEN(cb.token)
                storage.set(STORAGE.LOGIN_TOKEN, cb.token)
                session.set(STORAGE.LOGIN_TOKEN, cb.token)
                setTimeout(() => {
                  this.loginStatusChange = true
                  next()
                }, 300)
                await this.getUser()
              } else {
                await this.anonymityLogin()
                this.loginStatusChange = true
                next()
              }
            } catch (err) {
              console.log('err', err)
            }
            console.log('isinlogin getupdateuser end', !!storage.get(STORAGE.IS_IN_LOGIN))
          })
        }
      }, 1000)
    },
    getWebViewStatus (next) {
      if (!this.inApp) return
      timer2 = setInterval(() => {
        if (window.YTXBridge) {
          clearInterval(timer2)
          window.YTXBridge.registerHandler('webviewShow', (cb) => {
            try {
              console.log('data', cb)
              cb = JSON.parse(cb)
              next(cb.show)
            } catch (err) {
              console.log('err', err)
            }
          })
        }
      }, 1000)
    },
    onClickBack (next) {
      timer3 = setInterval(() => {
        if (window.YTXBridge) {
          clearInterval(timer3)
          window.YTXBridge.registerHandler('onClickBack', () => {
            try {
              next()
            } catch (err) {
              console.log('err', err)
            }
          })
        }
      }, 1000)
    }
    // getWechatAuthCode (next) {
    //   timer4 = setInterval(() => {
    //     if (window.YTXBridge) {
    //       clearInterval(timer4)
    //       window.YTXBridge.registerHandler('wechatAuthCode', (res) => {
    //         try {
    //           console.log('data', res)
    //           res = JSON.parse(res)
    //           next(res)
    //         } catch (err) {
    //           console.log('err', err)
    //         }
    //       })
    //     }
    //   }, 1000)
    // }
  }
}



// WEBPACK FOOTER //
// ./src/mixins/js-bridge.js